import moment from "moment";
import AddMeetingGuest from "@/components/Meetings/AddMeetingGuest";

export default {
    data(){
        return{
        };
    },
    methods: {
        optOut(id, type, val){
            let raw = {
                "id": id,
                "data": {}
            }
            raw.data[type] = val
            this.$app.huddleLabsServerCall('meetings/attendee/save', raw);
        },
        optOutHotel(){
            this.$store.dispatch('meetings/optOutHotel', true);
            this.optOut(this.$store.state.meetings.meetingInfo.attendeeId, 'noHotelRequired', true);
            this.meetingRouter();
        },
        meetingRouter(){
            let res = '/meetings'
            let route = this.$route.path
            let solution = this.$store.state.bookTravel.result;
            let meetingInfo = this.$store.state.meetings.meetingInfo
            // console.log(meetingInfo)
            if (route === '/meetings/attendee-details' && meetingInfo.meeting.survey && !this.$store.state.meetings.meetingSurveySet){
                res += '/survey'
            }
            else {
                if(meetingInfo.meeting.useFlightTool && !meetingInfo.noAirTravelRequired && !solution.flight.journeys && !meetingInfo.optedOutFlight && !meetingInfo.pnrRecordLocator){
                    res += '/flights'
                }
                //else if(solution.flight.journeys && this.$store.state.bookTravel.numGuests > this.$store.state.bookTravel.guests.length ){
                //    console.log('going to add guest page')
                //    res = '/meetings/flight-confirmation'
                //}
                else if(meetingInfo.meeting.useHotelTool && !meetingInfo.noHotelRequired && !solution.hotel.hotelCode && !meetingInfo.optedOutHotel && !meetingInfo.pnrRecordLocator){
                    res += '/hotels'
                }
                else if(meetingInfo.meeting.useCarTool && !meetingInfo.noCarRentalRequired && !solution.car.id && !meetingInfo.optedOutCar && !meetingInfo.pnrRecordLocator){
                    res += '/cars'
                }
                else if(!solution.car.id && !solution.hotel.hotelCode && !solution.flight.journeys){
                    res += '/confirmation'
                }
                else{
                    res += '/summary'
                }
            }
            // }
            this.$router.push({ path: res })
        },
        optOutFlight(){
            this.$store.dispatch('meetings/optOutFlight', true);
            this.optOut(this.$store.state.meetings.meetingInfo.attendeeId, 'noAirTravelRequired', true);
            this.meetingRouter();
        },
        setMeetingsDepartDate(val){
            this.meetingsDepartDate = val
        },
        setMeetingsReturnDate(val){
            this.meetingsReturnDate = val
        },
        setMeetingsDestination(val) {
            console.log('setMeetingsDestination', val)
            this.meetingsDestination = val;
            this.setValue2(val);
        },
        optOutCar(){
            this.$store.dispatch('meetings/optOutCar', true);
            this.optOut(this.$store.state.meetings.meetingInfo.attendeeId, 'noCarRentalRequired', true);
            this.meetingRouter()
        },
        meetingInputPU(val) {
            this.meetingDatePU = val;
            //this.$store.commit('bookTravel/ALTER_C_START_DATE', val);
        },
        meetingInputDO(val) {
            this.meetingDateDO = val;
            //this.$store.commit('bookTravel/ALTER_C_END_DATE', val);
        },
        setMeetingsPickup(val) {
            this.meetingsPickup = val
        },
        setMeetingsDropoff(val) {
            this.meetingsDropoff = val
        },
        labelForMeeting(type){
            let label = '';

            if(type == 'depart'){
                label += '<strong>Depart</strong> ';
                if(this.meetingInfo.meeting.latestArrival.time !== null){
                    label += `<span class="ml-2 is-size-7 is-italic gant-text">Arrive by
                        <b>${this.convertTime(this.meetingInfo.meeting.latestArrival.time)}</b>
                        on ${moment(this.meetingInfo.meeting.latestArrival.date).format('ddd, MMM D')}
                       </span>`;
                }
            }

            if(type == 'return'){
                label += '<strong>Return</strong> ';
                if(this.meetingInfo.meeting.earliestDeparture.time !== null){
                    label += `<span class="ml-2 is-size-7 is-italic gant-text">Depart no earlier than
                        <b>${this.convertTime(this.meetingInfo.meeting.earliestDeparture.time)}</b>
                        on ${moment(this.meetingInfo.meeting.earliestDeparture.date).format('ddd, MMM D')}
                       </span>`;
                }
            }

            return label;
        },
    },
    computed: {
        meetingInfo() {
            return this.$store.state.meetings.meetingInfo;
        },
        minMeetingDepartDate() {
            if (this.meetingInfo.meeting.earliestArrival.date) {
                return moment(this.meetingInfo.meeting.earliestArrival.date).toDate();
            }
            return moment().toDate();
        },
        maxMeetingReturnDate() {
            // console.log(this.meetingInfo.meeting.latestDeparture.date)
            if (this.meetingInfo.meeting.latestDeparture.date) {
                return moment(this.meetingInfo.meeting.latestDeparture.date).toDate();
            }
            return moment().add(340, 'd').toDate();
        },
        prefAirport() {
            var meeting = this.$store.state.meetings.meetingInfo.meeting
            var prefAirport = meeting.preferredAirports
            if (Array.isArray(prefAirport)) {
                return this.$helpers.findAirportByCode(prefAirport[0].trim());
                // return this.airportDetails(prefAirport[0])
            }
            else {
                return this.$helpers.findAirportByCode(prefAirport.trim());
                //return this.airportDetails(prefAirport)
            }
        },
        meetingAirports() {
            var meeting = this.$store.state.meetings.meetingInfo.meeting
            var prefAirports = meeting.preferredAirports
            var otherAirports = meeting.secondaryAirports

            console.log(prefAirports)
            console.log(otherAirports)

            var airports = []
            if (Array.isArray(prefAirports)) {
                for (let airport of prefAirports) {
                    let airportDetails = this.$helpers.findAirportByCode(airport.trim());
                    airports.push(airportDetails)
                }
            } else {
                airports.push(this.$helpers.findAirportByCode(prefAirports.trim()))
            }
            if (otherAirports) {
                if (Array.isArray(otherAirports)) {
                    for (let airport of otherAirports) {
                        let airportDetails = this.$helpers.findAirportByCode(airport.trim())
                        airports.push(airportDetails)
                    }
                } else {
                    airports.push(this.$helpers.findAirportByCode(otherAirports.trim()))
                }
            }

            console.log(airports)

            return airports
        },
        isMeetingMode() {
            if (this.$store.state.meetings.meetingInfo) {
                return true;
            }
            return false;
        },
        isMeeting(){
            return Boolean(this.$route.path.match(/(^\/meetings(?:\/((?:[^/]+?)))?(?:\/(?=$))?$)/));
        },
        isWorldStridesEnvisionLandingPage() {
            return this.$route.path === '/envision';
        },
        latestArrivalTime(){
            return this.meetingInfo.meeting.latestArrival.time;
        },
        earliestDepartureTime(){
            return this.meetingInfo.meeting.earliestDeparture.time;
        },
    },
}